module.exports = __webpack_public_path__ + "static/media/attach-file.044e94b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/attach-file.svg
// module id = 3272
// module chunks = 0